import { VueExtension } from '../../utils/extensions/vue.js';
import NavBar from './navbar.jsx';
import './navbar.scss';

VueExtension.WithInstall(NavBar);

export default NavBar;
